/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  return /^1[3456789]\d{9}$/.test(str);
}

/**
 * 邮箱校验
 * @param {string} str
 * @returns {Boolean}
 */
export function cnEmailReg(str) {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9\u4e00-\u9fa5.-]+\.[a-zA-Z\u4e00-\u9fa5]{2,}$/.test(
    str
  );
}

/**
 * 消息提醒
 * @param {Object} vm Vue组件实例（即组件内的this）
 * @param {string} message 提醒内容
 * @param {string} type 提醒的类型
 * @param {number} offset 距离顶部的距离
 */
export function onMsgHint(vm, message, type = "warning", offset = 20) {
  // 先校验实例和方法是否存在，避免报错
  if (vm && typeof vm.$message === "function") {
    vm.$message({
      message: message,
      type: type,
      offset: offset,
    });
  } else {
    console.warn("$message 方法不存在，请确认已正确引入 Element UI/Plus");
  }
}
